// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getContributionChart = (policyId: string, type: 'TOTAL' | 'REGULAR' | 'ADHOC') => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  return backendAxios.get(`/policies/${policyId}/contributions-chart?type=${type}&page=1`);
};

export default getContributionChart;
